module.exports = __webpack_public_path__ + "static/media/ash.59c87977.JPG";